import React from "react";

const DiagramSkeleton: React.FC = () => (
  <li className="flex flex-col items-start mb-2 shadow-md rounded-lg overflow-hidden">
    <div className="w-full bg-gray-100 p-2">
      <div className="h-6 w-3/4 bg-gray-200 rounded animate-pulse" />
    </div>
    <div className="p-4 w-full">
      <div className="h-4 w-full bg-gray-200 rounded animate-pulse mb-2" />
      <div className="h-4 w-2/3 bg-gray-200 rounded animate-pulse mb-4" />
      <div className="w-full h-48 bg-gray-200 rounded animate-pulse">
        <div className="flex justify-center items-center h-full">
          <span className="text-gray-400">Generating diagram...</span>
        </div>
      </div>
      <div className="flex gap-2 mt-2">
        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse" />
        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse" />
      </div>
    </div>
  </li>
);

export default DiagramSkeleton;
